export const MAX_ITEMS_TO_SHOW_MOBILE = 3;
export const MAX_ITEMS_TO_SHOW_DESKTOP = 5;
